import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
import { calcFoldText } from '@cronos-app/utils';
import { useMemo } from 'react';
export const FoldDecimal = ({ value, prependZeroCount = 3, ignoreNotPure = false, ...restProps }) => {
    const child = useMemo(() => {
        const info = calcFoldText(value, prependZeroCount, ignoreNotPure);
        if (!info)
            return value;
        const [count, s, e] = info;
        return (_jsxs(_Fragment, { children: [value.slice(0, s), "0", _jsx(Text, { as: "span", display: "inline-block", transform: "scale(.7)", transformOrigin: "45% 80%", children: count }), value.slice(e)] }));
    }, [value, prependZeroCount, ignoreNotPure]);
    return _jsx(Text, { ...restProps, children: child });
};
